const ratingJobResponseToRatingJobObject = (response) => {
    return {
        id: response.id,
        createdAt: response.created_at,
        userId: response.user_id,
        integrationId: response.integration_id,
        jobExecutionId: response.job_execution_id,
        ratingProcessingStatus: response.rating_processing_status,
    };
};

export { ratingJobResponseToRatingJobObject };
